import React from "react"

import PropTypes from "prop-types"

import * as styles from "./newsletter-table.module.scss"
import Heading from "../../atoms/heading"

const NewsletterTable = ({ section, color }) => (
  <div className={styles.wrapper}>
    <table className={styles.table} cellPadding="0" cellSpacing="0">
      <tbody>
        {section.table.rows.map((row, rindex) => (
          <tr
            className={`${styles.row} ${rindex === 0 ? `${styles.row__heading} ${styles[`row__${color}`]}` : ""}`}
          >
            {row.cells.map((cell, cindex) => (
              <td
                className={`${styles.cell} ${cindex === 0 ? styles.cell__first : ""}`}
              >
                {rindex === 0 ? <Heading level={5}>{cell}</Heading> : cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)

export default NewsletterTable

NewsletterTable.propTypes = {
  section: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
}
